export const cashFlow = [
    {
        id: 0,
        month: "Janeiro",
        year: 2023,
        entrance: 0,
        exit: 0
    },
    {
        id: 1,
        month: "Fevereiro",
        year: 2023,
        entrance: 0,
        exit: 0
    },
    {
        id: 2,
        month: "Março",
        year: 2023,
        entrance: 0,
        exit: 0
    },
    {
        id: 3,
        month: "Abril",
        year: 2023,
        entrance: 0,
        exit: 0
    },
    {
        id: 4,
        month: "Maio",
        year: 2023,
        entrance: 0,
        exit: 0
    }
]